import styled from "styled-components";
import { Button } from "@mui/material";
import { Input as BaseInput } from "./PersonalInfoStep";

export const AuthContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2rem;
  min-height: 100vh;
  background-color: ${({ theme }) => theme.colors.backgroundLightPrimary};
`;

export const FormWrapper = styled.div`
  background: #ffffff;
  padding: 32px;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  width: 100%;
  max-width: 450px;
  text-align: center;
`;

export const ConfirmButton = styled(Button)<{ disabled?: boolean }>`
  && {
    width: 100%;
    height: 60px;
    font-weight: bold;
    color: #fff;
    background-color: ${({ disabled }) => (disabled ? "#D3D3D3" : "#E39435")};
    border: 1px solid ${({ disabled }) => (disabled ? "#D3D3D3" : "#E2E2E2")};
    box-shadow: none;

    &:hover {
      background-color: ${({ disabled }) => (disabled ? "#D3D3D3" : "#D4872D")};
      box-shadow: none;
    }
  }
`;

export const PasswordInput = styled(BaseInput)`
  && {
    margin-top: 0;
  }
`;

export const StyledLockIcon = styled.div`
  margin-top: 10px;
  margin-right: 16px;
  margin-left: 4px;
  color: #e39435;
  display: flex;
  align-items: center;
`;
